/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useContext, useState } from "react"
import PlannedServices1 from "../Forms/B/PlannedServices/PlannedServices1"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const PlannedServices1Container = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, loadCollection, handleLoadPrev } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingPlannedServices, setIsGettingPlannedServices] = useState(true)

  const toast = useRef()

  useEffect(() => {
    setIsGettingPlannedServices(true)
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      handleSubmitGet(endpoints.GET_PLANNED_SERVICES_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.PLANNED_SERVICES_1,
      })
        .then((response) => {
          if (response.status === 204 || response.status === 200) {
            loadCollection(
              setValues(response.data),
              INTERVIEW_SECTIONS.PLANNED_SERVICES_1
            )
            handleLoadPrev(false)
            setIsGettingPlannedServices(false)
          }
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingPlannedServices(false)
        })
    }
  }, [])

  const setValues = (data) => {
    return {
      gpra_b_services_mod_1: data?.form?.gpraBServicesMod1 ?? false,
      gpra_b_services_mod_2: data?.form?.gpraBServicesMod2 ?? false,
      gpra_b_services_mod_3: data?.form?.gpraBServicesMod3 ?? false,
      gpra_b_services_mod_4: data?.form?.gpraBServicesMod4 ?? false,
      gpra_b_services_mod_5: data?.form?.gpraBServicesMod5 ?? false,
      gpra_b_services_mod_6a: data?.form?.gpraBServicesMod6a ?? false,
      gpra_b_services_mod_6b: data?.form?.gpraBServicesMod6b ?? false,
      gpra_b_services_mod_6c: data?.form?.gpraBServicesMod6c ?? false,
      gpra_b_services_mod_6d: data?.form?.gpraBServicesMod6d ?? false,
      gpra_b_services_mod_6e: data?.form?.gpraBServicesMod6e ?? false,
      gpra_b_services_mod_6f: data?.form?.gpraBServicesMod6f ?? false,
      gpra_b_services_mod_6g: data?.form?.gpraBServicesMod6g ?? false,
      gpra_b_services_mod_6h: data?.form?.gpraBServicesMod6h ?? false,
      gpra_b_services_mod_6i: data?.form?.gpraBServicesMod6i ?? false,
      gpra_b_services_mod_7: data?.form?.gpraBServicesMod7 ?? false,
      gpra_b_services_mod_8a: data?.form?.gpraBServicesMod8a ?? false,
      gpra_b_services_mod_8b: data?.form?.gpraBServicesMod8b ?? false,
      gpra_b_services_mod_8c: data?.form?.gpraBServicesMod8c ?? false,
      gpra_b_services_mod_9: data?.form?.gpraBServicesMod9 ?? false,
      gpra_b_services_mod_10: data?.form?.gpraBServicesMod10 ?? false,
      gpra_b_services_mod_11: data?.form?.gpraBServicesMod11 ?? false,
      gpra_b_services_mod_11a: data?.form?.gpraBServicesMod11a ?? "",
      gpra_b_services_id: data?.form?.gpraBServicesId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingPlannedServices) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingPlannedServices && (
        <PlannedServices1 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default PlannedServices1Container
